export const PARSE_FILES_ACTIONS = {
  UPLOAD: 'PARSE_FILES_UPLOAD'
};